/**
 * Microsoft Entra ID authentication configuration for MSAL.js
 */

// Te wartości będą pobierane z backendu po utworzeniu App Registration w Azure
// Funkcja do określenia redirect URI - wymusza localhost
const getRedirectUri = () => {
  const origin = window.location.origin;
  // Zamień 127.0.0.1 na localhost, bo Azure Portal nie akceptuje IP
  return origin.replace('127.0.0.1', 'localhost');
};

export const msalConfig = {
  auth: {
    clientId: '', // Application (client) ID z Azure Portal
    authority: '', // https://login.microsoftonline.com/{tenant-id}
    redirectUri: getRedirectUri(), // Wymusza localhost zamiast 127.0.0.1
    postLogoutRedirectUri: getRedirectUri(),
    navigateToLoginRequestUrl: false
  },
  cache: {
    cacheLocation: 'sessionStorage', // sessionStorage lub localStorage
    storeAuthStateInCookie: true // MUSI być true dla Azure Web Apps - naprawia redirect loop
  }
};

// Scopes (uprawnienia) wymagane przez aplikację
export const loginRequest = {
  scopes: [
    'openid',
    'profile', 
    'User.Read' // pozwala na odczyt profilu użytkownika
  ]
};

// Scopes dla wywołań API (do backendu)
export const apiRequest = {
  scopes: [`api://${msalConfig.auth.clientId}/access_as_user`] // custom scope do API
};

// Graph API scopes (opcjonalne)
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me'
};

// Funkcja do dynamicznego ładowania konfiguracji z backendu
export const loadAuthConfig = async () => {
  // Jeśli autoryzacja jest wyłączona w środowisku DEV
  if (process.env.REACT_APP_DISABLE_AUTH === 'true') {
    console.log('🔓 Azure Auth DISABLED - running in DEV mode');
    return { configured: false };
  }
  
  try {
    // Dynamiczne określenie API URL
    const apiUrl = process.env.REACT_APP_API_URL || 
                   (window.location.hostname === 'localhost' 
                     ? 'http://localhost:8000/api' 
                     : `${window.location.origin}/api`);
    
    const response = await fetch(`${apiUrl}/auth/config`);
    if (response.ok) {
      const config = await response.json();
      
      // Aktualizuj konfigurację MSAL
      msalConfig.auth.clientId = config.client_id;
      msalConfig.auth.authority = config.authority;
      
      // Aktualizuj API scopes
      apiRequest.scopes = [`api://${config.client_id}/access_as_user`];
      
      return config;
    } else {
      console.warn('Could not load auth config from backend');
      return null;
    }
  } catch (error) {
    console.error('Error loading auth config:', error);
    return null;
  }
};

// Sprawdź czy konfiguracja jest kompletna
export const isAuthConfigured = () => {
  return msalConfig.auth.clientId && msalConfig.auth.authority;
};